import Car from './car';
import Loading from './loading';
import WorldLike from './worldLike';

export default {
  car: Car,
  loading: Loading,
  'world-like': WorldLike,
};
